import { useUseEnabledFeaturePreviewsFeaturePreviewsQuery } from '../graphql'

const useEnabledFeaturePreviews = () => {
  const { data } = useUseEnabledFeaturePreviewsFeaturePreviewsQuery()
  return data?.featurePreviews.map((feature) => feature.name) || []
}

export default useEnabledFeaturePreviews
